const auth0Url = CONFIG.auth.url;
const auth0ClientId = CONFIG.auth.clientID;
const redirectUri = CONFIG.auth.redirectUri;

export const getSsoTestUrl = (orgGroupId: string) => {
  // eslint-disable-next-line max-len
  return `${auth0Url}/authorize?response_type=token&redirect_uri=${redirectUri}/auth/test&client_id=${auth0ClientId}&scope=openid%20profile%20email&connection=${orgGroupId}`;
};
